<script>
import BaseButton from "../BaseButton.vue";

export default {
  name: "BaseButtonGroup",
  components: { BaseButton },
  props: {
    value: [String, Number, Boolean],
    options: Array,
  },
  methods: {
    click(e) {
      this.$emit('input', e);
    },
  },
}
</script>

<template lang="pug">
  .buttons
    BaseButton(v-for="option in options" :key="option" :md="true" :blue="value === option" :grey="value !== option" @click="click(option)") {{ option }}
</template>

<style scoped lang="scss">
.buttons {
  display: flex;
  :not(:first-child, :last-child) {
    border-radius: 0;
  }
  :first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  :last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
